const queuedText = new WeakMap();

const style = document.createElement( 'style' );
style.innerHTML = `
	.animated-text__line {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 0 .3em;
	}
	.animated-text__word {
		display: flex;
	}
	.animated-text__letter {
		opacity: 0;
		transition: all 0.5s ease;
		transform: translateY(50px);
	}
	.animated-text__letter--visible {
		opacity: 1;
		transform: translateY(0px);
	}
`;
document.head.appendChild( style );

function queueText( element ) {
	element.innerHTML = element.innerHTML.replace( '<br>', '\n' );
	const text = element.textContent;

	const letters = [];
	element.textContent = '';
	text.split( '\n' ).forEach( line => {
		const lineSpan = document.createElement( 'span' );
		lineSpan.className = 'animated-text__line';
		line.trim().split( / +/g ).forEach( word => {
			const wordSpan = document.createElement( 'span' );
			wordSpan.className = 'animated-text__word';
			word.split( '' ).forEach( letter => {
				const letterSpan = document.createElement( 'span' );
				letterSpan.className = 'animated-text__letter';
				letterSpan.innerText = letter;
				wordSpan.appendChild( letterSpan );
				letters.push( letterSpan );
			} );
			lineSpan.appendChild( wordSpan );
		} );
		element.appendChild( lineSpan );
	} );

	let chars = 0;

	let lastUpdate = performance.now();

	function onTick() {
		const now = performance.now();
		const elapsed = now - lastUpdate;
		const toAdd = Math.round( elapsed / 50 );

		if ( toAdd > 0 ) {
			for ( let i = 0; i < toAdd; i++ ) {
				const span = letters[ chars ];
				span.classList.add( 'animated-text__letter--visible' );
				chars++;
			}

			lastUpdate = now;
		}

		if ( chars < letters.length ) {
			requestAnimationFrame( onTick );
		}
	}

	onTick();

	return letters;
}

const animateTextObserver = new IntersectionObserver( changes => {
	changes.forEach( change => {
		if ( change.isIntersecting && ! queuedText.has( change.target ) ) {
			queuedText.set( change.target, queueText( change.target ) );
		}
	} );
} );

document.querySelectorAll( '.animated-text' ).forEach( element => {
	animateTextObserver.observe( element );
} );
